import { ChipProps as ChipBaseProps, Typography } from '@cmg/design-system';
import isToday from 'date-fns/isToday';
import isValidDate from 'date-fns/isValid';
import parseISODate from 'date-fns/parseISO';
import type { ReactNode } from 'react';

import type { CalendarGridRowData } from '../../CalendarGrid.model';

type GetIssuerChipArgs = {
  offering: CalendarGridRowData | null | undefined;
};

type ChipProps = ChipBaseProps & {
  tooltip?: ReactNode;
};

const CHIPS: Record<string, (args: GetIssuerChipArgs) => ChipProps | undefined> = {
  Accelerated: ({ offering }) => {
    if (offering?.attributes?.isAccelerated) {
      return {
        label: 'Acc.',
        color: 'warning',
        tooltip: (
          <Typography variant="tooltip">
            <Typography variant="tooltip" component="span" fontWeight="bold">
              Accelerated
            </Typography>
            <br />
            Offering's timeline is expedited and priced at an earlier date than previously indicated
          </Typography>
        ),
      };
    }
  },
  Today: ({ offering }) => {
    const launchDate = parseISODate(offering?.attributes?.launchDate ?? '');

    if (isValidDate(launchDate) && isToday(launchDate)) {
      return {
        label: 'Today',
        color: 'primary',
        tooltip: (
          <Typography variant="tooltip" component="span" fontWeight="bold">
            Offering Launched today
          </Typography>
        ),
      };
    }
  },
};

export const getIssuerChips = (props: GetIssuerChipArgs): ChipProps[] => {
  return Object.values(CHIPS)
    .map(getChipConfig => getChipConfig(props))
    .filter((chipConfig): chipConfig is ChipProps => !!chipConfig);
};
